export class BackupZeroEtlSingleResourcePartitionConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "icebergPartitionSpec",
            "baseName": "icebergPartitionSpec",
            "type": "BackupZeroEtlIcebergPartitionSpec",
            "format": ""
        },
        {
            "name": "orderingSpec",
            "baseName": "orderingSpec",
            "type": "BackupZeroEtlOrderingSpec",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlSingleResourcePartitionConfig.attributeTypeMap;
    }
    constructor() {
    }
}
